import { h } from "preact";

const CardIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="40"
    height="26"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path d="M24 11H0V7H24V11Z" fill="#002649" />
    <path
      opacity="0.4"
      d="M21.3333 3C22.8042 3 24 4.19375 24 5.66667V7H0V5.66667C0 4.19375 1.19375 3 2.66667 3H21.3333ZM24 19C24 20.4708 22.8042 21.6667 21.3333 21.6667H2.66667C1.19375 21.6667 0 20.4708 0 19V11H24V19ZM4.66667 16.3333C4.3 16.3333 4 16.6333 4 17C4 17.3667 4.3 17.6667 4.66667 17.6667H7.33333C7.7 17.6667 8 17.3667 8 17C8 16.6333 7.7 16.3333 7.33333 16.3333H4.66667ZM10 17.6667H15.3333C15.7 17.6667 16 17.3667 16 17C16 16.6333 15.7 16.3333 15.3333 16.3333H10C9.63333 16.3333 9.33333 16.6333 9.33333 17C9.33333 17.3667 9.63333 17.6667 10 17.6667Z"
      fill="#002649"
    />
  </svg>
);

export default CardIcon;
